function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBackground = function SvgBackground(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 561 1071",
    ref: svgRef
  }, props), React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, React.createElement("g", {
    id: "B_02_ECRAN_OEUVRE_BLOQUE"
  }, React.createElement("g", {
    id: "_02",
    "data-name": 2
  }, React.createElement("g", null, React.createElement("path", {
    d: "M280.5,0h0C435.42,0,561,125.58,561,280.5v510C561,945.42,435.42,1071,280.5,1071h0C125.58,1071,0,945.42,0,790.5v-510C0,125.58,125.58,0,280.5,0Z",
    style: {
      fill: "none"
    }
  }), React.createElement("path", {
    d: "M280.5,121.5h0c103.83,0,188,84.17,188,188v463c0,103.83-84.17,188-188,188h0c-103.83,0-188-84.17-188-188v-463C92.5,205.67,176.67,121.5,280.5,121.5Z",
    style: {
      fill: "none",
      stroke: "#efcaca",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), React.createElement("path", {
    d: "M281,234.5h0A109.49,109.49,0,0,1,390.5,344V727A109.49,109.49,0,0,1,281,836.5h0A109.49,109.49,0,0,1,171.5,727V344A109.49,109.49,0,0,1,281,234.5Z",
    style: {
      fill: "none",
      stroke: "#efcaca",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }))))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBackground, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/background.342d91d6.svg";
export { ForwardRef as ReactComponent };